import { render, staticRenderFns } from "./Org_requests.vue?vue&type=template&id=c587480c"
import script from "./Org_requests.vue?vue&type=script&lang=js"
export * from "./Org_requests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports